import styled from 'styled-components';

interface IChevronSVGProps {
  isOpen: boolean;
}

export const ChevronSVG = styled('svg')<IChevronSVGProps>`
  transform: ${(props) => (props.isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
  transition: transform 0.3s ease;
`;
